import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const MagazineSpread = ({
  image,
  imageFirst,
  imageAlt,
  children,
  letterbox,
  imageSml,
  dossier,
}) => (
  <div
    className={clsx(
      'ss_magazine-spread',
      !imageFirst && 'ss_row-reverse',
      dossier && 'ss_magazine-spread--dossier',
    )}
  >
    <img
      src={image}
      alt={imageAlt}
      className={clsx(
        'ss_magazine-spread__img',
        letterbox && 'ss_magazine-spread__img--letterbox',
        imageSml && 'ss_magazine-spread__img--sml',
        dossier && 'ss_magazine-spread__img--dossier',
      )}
    />
    <div
      className={clsx(
        'ss_magazine-spread__copy',
        imageSml && 'ss_magazine-spread__copy--lg',
      )}
    >
      {children}
    </div>
  </div>
);

MagazineSpread.defaultProps = {
  imageFirst: false,
  letterbox: false,
  imageSml: false,
  dossier: false,
};

MagazineSpread.propTypes = {
  imageAlt: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageFirst: PropTypes.bool,
  children: PropTypes.node.isRequired,
  letterbox: PropTypes.bool,
  imageSml: PropTypes.bool,
  dossier: PropTypes.bool,
};

export default MagazineSpread;
